import { Location } from "react-router-dom";

// for create BREADCRUMB

const transformString = (str: string) => {
  let words = str.split("-");

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  return words.join(" ");
};

export const getHeadMenus = (location: Location) => {
  if (!location?.pathname || location.pathname === "/") return "HOME";

  const splitPath = location.pathname.split("/")[1].replace("vocs", "VOCs");

  return transformString(splitPath);
};

export const mapReplaceWord: Record<string, string> = {
  Information: "",
  "Voc ": "VOCs ",
  // Voc: "VOCs ",
  Vocs: "VOCs",
  "Setup ": "",
  "Manual ": "",
  "Report ": "",
  And: "&",
  Government: "รายงานราชการ",
  "Waste Water Treatment": "Wastewater",
  "VOCs Tank": "VOCs Tank 4.0",
  "Stop Voc": "Stop VOCs",
};
const blackListNotReplaceKey = ["/vocs-inventory/others/information"];

export const getBreadcrumbCapitalize = (str: string, pathname?: string) => {
  let result = transformString(str);
  // console.log("strxxx : ", str);
  for (const key in mapReplaceWord) {
    // Check if the current key is "Information"
    // For "Information", replacement happens only if it is the prefix of the result
    if (key === "Information") {
      if (result.split(" ")[0] === "Information") {
        if (pathname && blackListNotReplaceKey.includes(pathname)) {
        } else result = result.replace(key, mapReplaceWord[key]);
      }
    } else {
      result = result.replace(key, mapReplaceWord[key]);
    }
  }
  if (result.includes("Masterdata")) result = result.replace("Masterdata", "Master Data");
  return result;
};
